export default __webpack_public_path__ + "static/media/photo-2.9ead6db3.jpg";